module.exports = __webpack_public_path__ + "img/rejected.16636212.png";